import $ from "jquery"; // Import jQuery
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import useFocusedRowHighlight from "../../../../hooks/useFocusedRowHighlight";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { ProgressSpinner } from "primereact/progressspinner";
import Select from "react-select";

const Create = () => {
  const { checkRequiredFields } = useRequiredFields();
  const { getRowProps } = useFocusedRowHighlight();
  const navigate = useNavigate();
  // const { id } = useParams();
  const deflautSearchValue = useRef();
  const searchTimeout = useRef(null);

  const [inputs, setInputs] = useState({
    receipt_no: "",
    production_work_order_id: "",
    date: "",
    receive_date: "",
    entry_date: new Date().toISOString().split("T")[0],
    copy_type: "",
    purchase_type: "",
    from_department: "",
    to_department: "",
    status: "requested",
    remarks: "",
    filter_cake_id: "",
  });

  // const [defaultValue, setDefaultValue] = useRef();

  const [list, setList] = useState([]);
  const [error, setError] = useState({});
  const [planningId, setPlanningId] = useState({});
  const [planningOptions, setPlanningOptions] = useState([]);
  const [role, setRole] = useState("");
  const [itemLoading, setItemLoading] = useState(false);
  const [searchProducts, setSearchProducts] = useState("");
  const [random, setRandom] = useState();
  const [loading, setLoading] = useState(false);
  const [allItemsWithInput, setAllItemsWithInput] = useState(new Map());
  const [showPagination, setShowPagination] = useState(true);
  const [filterCakeOptions, setFilterCakeOptions] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 15,
    total: 0,
    last_page: 1,
  });
  const [isInitialLoadComplete, setIsInitialLoadComplete] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const getUniquePlanningData = (items) => {
    const map = new Map();

    items.forEach((item) => {
      const key = [
        item.product_id,
        item.shape_id,
        item.production_work_order?.id,
        item.production_work_order?.company?.id,
        item.production_work_order_item?.glaze_id ?? "",
        item.production_work_order_item?.color_id ?? "",
        item.production_work_order_item?.decoration_code ?? "",
      ].join("_");

      if (!map.has(key)) {
        map.set(key, item);
      }
    });

    return Array.from(map.values());
  };

  const fetchData = async (page = 1) => {
    setLoading(true);
    try {
      const resRole = await Http.get("/staff-type-check");
      const fetchedRole = resRole.data;
      setRole(fetchedRole);

      const resPlanning = await Http.get("/planning?production=1");
      const planningData = resPlanning.data;

      // Set only unique data
      setPlanningOptions(planningData);

      const firstPlanning = planningData[0];
      if (planningData.length > 0) {
        // Automatically select the first planning and set in inputs
        setInputs((prevInputs) => ({
          ...prevInputs,
          planning_id: firstPlanning.id, // Assuming the ID field for planning
        }));

        // Load items for the first planning
        await handlePlanningChange(firstPlanning.id);
      }

      // Fetch the receipt number
      const resReceiptNo = await Http.get(
        "/last-code-increment-by-one/production_finished_goods/receipt_no/P",
      );
      const receiptNo = resReceiptNo.data; // Assuming the API returns the receipt number directly

      // Set the fetched receipt number to inputs
      setInputs((prevInputs) => ({
        ...prevInputs,
        receipt_no: receiptNo,
      }));

      // Fetch filter cake options
      const resFilterCake = await Http.get("/product-list-body-return");
      setFilterCakeOptions(resFilterCake.data);
      setInputs((prevInputs) => ({
        ...prevInputs,
        filter_cake_id: 1,
      }));

      // const firstPlanningData = await Http.get(`/planning/${resPlanning.data[0].id}?production=1`)
      // console.log(firstPlanningData, 'firstPlanningData')
      // // Filter unique by product_id

      // const productionTransferInfo = firstPlanningData?.data?.production_transfer_info;
      // const filteredItems = firstPlanningData?.data?.items;

      // const updatedFilteredItems = filteredItems.map((item) => {
      //   const productId = item.product_id;
      //   const planningItemId = item.id;

      //     return {
      //       id: item.id,
      //       planning_id: item.planning_id,
      //       product_id: productId,
      //       product_name: item.product.name,
      //       shape: item.shape?.name,
      //       production_work_order: item.production_work_order?.receipt_no,
      //       company: item.production_work_order?.company?.name,
      //       product_code: item.product.code,
      //       planning_qty: item.qty,
      //       production_qty: 0,
      //       return_qty: 0,
      //       transfer_qty: "",
      //       total_production_qty:
      //         productionTransferInfo[planningItemId]?.production_qty || 0, // Map production_qty
      //       total_transfer_qty: item.total_transfer_qty || 0, // Map transfer_qty
      //       current_stock:
      //         productionTransferInfo[planningItemId]?.current_stock || 0, // Added current_stock
      //       // available_qty: productionTransferInfo[planningItemId]?.production_qty - item.total_transfer_qty, // Added current_stock
      //       slice_weight: item.slice_weight, // Example if qty is used as slice_weight
      //       closing_balance: 0, // Placeholder for closing balance
      //       remarks_delivery: "", // Set to empty or adjust if needed
      //       decoration_code: item?.production_work_order_item?.decoration_code,
      //       decoration_name: item?.production_work_order_item?.decoration_name,
      //     };
      //   });
      // console.log(updatedFilteredItems, "filteredItems");
      // setList(updatedFilteredItems);
      // setOriginalList(updatedFilteredItems);
      // console.log(list, "list");

      // const response = await Http.get(`/planning/${planningId}?page=${page}&limit=${pagination.per_page}`);

      // const planningItems = response.data.items.map((item) => ({
      //   id: item.id,
      //   product_id: item.product_id,
      //   product_name: item.product.name,
      //   qty: item.qty,
      //   total_received_qty: item.total_received_qty,
      //   current_stock: item.current_stock,
      //   total_loss_qty: item.total_loss_qty,
      //   total_transfer_qty: item.total_transfer_qty,
      //   // Add other necessary fields...
      // }));

      // setList(planningItems);
      // setOriginalList(planningItems);

      // Update pagination state
      // setPagination(response.data.pagination);
    } catch (e) {
      console.error("Error fetching data:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    $("body").addClass("collapse-menu");
    // $("body").toggleClass("show-left");
    fetchData();
  }, [isInitialLoadComplete]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const [originalList, setOriginalList] = useState([]);
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const updatedList = [...list];
    // let inputValue = parseFloat(value) || 0;
    let inputValue = value === "" ? 0 : parseFloat(value);

    if (name === "transfer_qty" || name === "return_qty") {
      let transferQty = list[index]?.transfer_qty || 0;
      let returnQty = list[index]?.return_qty || 0;

      if (name === "transfer_qty") {
        transferQty = inputValue;
      } else {
        returnQty = inputValue;
      }
      // Check if the closing balance would be less than 0
      const closingBalance =
        (list[index].current_stock || 0) +
        (list[index].production_qty || 0) -
        (transferQty || 0) -
        (returnQty || 0);

      // Adjust inputValue if it causes closing balance to be less than 0
      console.log(closingBalance, "closingBalance");
      /* artisan er 1st june er stock pawa porjonto eta temporary vabe off thakbe */

      if (closingBalance < 0) {
        Swal.fire({
          icon: "error",
          title: "Closing balance cannot be Negative",
        });
        inputValue = 0; // Reset to 0 to prevent negative closing balance
      }
      //  */
    }

    updatedList[index][name] = inputValue;
    if (name === "green_weight") {
      const stock = Number(
        (filterCakeOptions.find((o) => o.value === inputs.filter_cake_id) || {})
          .stockQty || 0,
      );
      const totalKg = updatedList.reduce(
        (sum, it) => sum + (Number(it.green_weight) || 0) / 1000,
        0,
      );
      const remaining = stock - totalKg;
      if (remaining < 0) {
        Swal.fire("Error!", "Filter cake stock cannot be less than 0", "error");
        updatedList[index][name] = 0;
      }
    }
    setList(updatedList);

    const itemId = updatedList[index].id;
    setAllItemsWithInput((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(itemId, { ...updatedList[index] });
      return newMap;
    });
  };

  const formSubmit = () => {
    if (!checkRequiredFields()) {
      return;
    }
    // const allItemsArray = Array.from(allItemsWithInput.values());
    // const formData = {
    //   ...inputs,
    //   items: allItemsArray,
    // };

    let allItemsArray = Array.from(allItemsWithInput.values());
    const stock = Number(
      (filterCakeOptions.find((o) => o.value === inputs.filter_cake_id) || {})
        .stockQty || 0,
    );
    const totalKg = allItemsArray.reduce(
      (sum, it) => sum + (Number(it.green_weight) || 0) / 1000,
      0,
    );
    if (stock - totalKg < 0) {
      Swal.fire("Error!", "Filter cake stock cannot be less than 0", "error");
      return;
    }
    if (inputs.filter_cake_id) {
      allItemsArray = allItemsArray.map((item) => ({
        ...item,
        filter_cake_id: inputs.filter_cake_id,
      }));
    }
    const formData = {
      ...inputs,
      items: allItemsArray,
    };

    // ADDED: confirmation prompt before submitting
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to submit this transfer?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, submit",
      cancelButtonText: "Cancel",
    }).then((result) => {
      // if (!result.isConfirmed) return;
      if (!result.isConfirmed) {
        setIsSubmitting(false); // ADDED: reappear on cancel
        return;
      }

      Http.post(`/production-transfer`, formData)
        .then((res) => {
          navigate("/transfer-art", {
            state: { message: res.data.message, type: "success" },
          });
        })
        // .catch(function (e) {
        //   setError(e.response.data.errors);
        // });
        .catch((e) => {
          const responseData = e.response?.data;
          const errors = responseData?.errors;

          // Stock validation errors come back as a plain array of message strings
          if (Array.isArray(errors) && errors.length > 0) {
            Swal.fire({
              icon: "error",
              title: responseData.message || "Validation Error",
              html: `<ul style="text-align:left; margin:0; padding-left:20px;">
                   ${errors.map((msg) => `<li>${msg}</li>`).join("")}
                 </ul>`,
            });
            return;
          }

          // Fallback: laravel-style field validation errors (object, not array)
          setError(errors || {});
          Swal.fire({
            icon: "error",
            title: "Validation Error",
            text:
              responseData?.message ||
              "Something went wrong. Please check the form.",
          });
        });
    });
  };

  const handlePlanningChange = async (planningId, page = 1) => {
    setLoading(true);
    if (!planningId) return;

    // Reset all form data when planning changes
    // setList([]); // Clear the current list
    // setOriginalList([]); // Clear original list
    // setAllItemsWithInput(new Map()); // Clear the items map
    // setSearchProducts(""); // Clear search input

    setPlanningId(planningId);
    setInputs((prevInputs) => ({
      ...prevInputs,
      planning_id: planningId, // Update planning_id in inputs
    }));

    try {
      // Fetch data based on selected planning ID
      const response = await Http.get(
        `/planning/${planningId}?production=1&page=${page}&limit=${pagination.per_page}`,
      );

      // Extract production_transfer_info for mapping quantities
      const productionTransferInfo = response.data.production_transfer_info;
      const filteredItems = response?.data?.items;

      const updatedFilteredItems = filteredItems.map((item) => {
        const productId = item.product_id;
        const planningItemId = item.id;
        const existingItem = allItemsWithInput.get(item.id);

        const baseItem = {
          id: item.id,
          planning_id: item.planning_id,
          product_id: productId,
          product_name: item.product.name,
          shape: item.shape?.name,
          production_work_order: item.production_work_order?.receipt_no,
          company: item.production_work_order?.company?.name,
          product_code: item.product.code,
          planning_qty: item.qty,
          production_qty: 0,
          return_qty: 0,
          transfer_qty: "",
          total_production_qty:
            productionTransferInfo[planningItemId]?.production_qty || 0, // Map production_qty
          total_transfer_qty: item.total_transfer_qty || 0, // Map transfer_qty
          current_stock:
            productionTransferInfo[planningItemId]?.current_stock || 0, // Added current_stock
          slice_weight: item.slice_weight, // Example if qty is used as slice_weight
          closing_balance: 0, // Placeholder for closing balance
          remarks_delivery: "", // Set to empty or adjust if needed
          decoration_code: item?.production_work_order_item?.decoration_code,
          decoration_name: item?.production_work_order_item?.decoration_name,
          glaze_id: item?.production_work_order_item?.glaze_id,
          status: item?.production_work_order?.status,
        };
        // if (existingItem) {
        //   return existingItem;
        // } else {
        //   // Store the new item in the map
        //   return baseItem;
        // }

        return existingItem || baseItem;
      });
      setList(updatedFilteredItems);
      setOriginalList(updatedFilteredItems);
      setPagination(response.data.pagination);

      // Update the global map with new items (only if they don't already exist)
      setAllItemsWithInput((prevMap) => {
        const newMap = new Map(prevMap);
        updatedFilteredItems.forEach((item) => {
          if (!newMap.has(item.id)) {
            newMap.set(item.id, item);
          }
        });
        return newMap;
      });
      setLoading(false);
    } catch (error) {
      console.error("Error fetching products for planning:", error);
      Swal.fire(
        "Error!",
        "Failed to fetch products for the selected planning.",
        "error",
      );
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".fixed-header");
      if (header) {
        // Add null check
        if (window.scrollY > 100) {
          header.classList.add("header-scrolled");
        } else {
          header.classList.remove("header-scrolled");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup function
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const cols = [{ field: "name", header: "Item" }];

  // Debounced search function that makes the actual API call
  const debouncedSearch = useCallback(
    async (searchValue, planningId, page = 1) => {
      setLoading(true);
      setShowPagination(true);

      if (searchValue.trim() === "") {
        setIsInitialLoadComplete(!isInitialLoadComplete);
        // // Restore original list when input is empty
        setList(originalList);
        setShowPagination(true);

        // // Keep loading state for a moment to show the transition
        // setTimeout(() => {
        //   setLoading(false);
        // }, 300);
        return;
      }

      try {
        // const response = await Http.post(`/search-products`, {
        //   search: searchValue,
        //   planningId,
        // });
        const response = await Http.get(
          `/planning/${planningId}?production=1&page=${page}&limit=${pagination.per_page}&product_name=${searchValue}`,
        );
        // Extract production_transfer_info for mapping quantities
        const productionTransferInfo =
          response.data.production_transfer_info || {};
        const filteredItems = response?.data?.items || [];

        const updatedFilteredItems = filteredItems.map((item) => {
          const productId = item.product_id;
          const planningItemId = item.id;
          const existingItem = allItemsWithInput.get(item.id);

          const baseItem = {
            id: item.id,
            planning_id: item.planning_id,
            product_id: productId,
            product_name: item.product.name,
            shape: item.shape?.name,
            production_work_order: item.production_work_order?.receipt_no,
            company: item.production_work_order?.company?.name,
            product_code: item.product.code,
            planning_qty: item.qty || 0,
            production_qty: 0,
            return_qty: 0,
            transfer_qty: "",
            total_production_qty:
              productionTransferInfo[planningItemId]?.production_qty || 0, // Map production_qty
            total_transfer_qty: item.total_transfer_qty || 0, // Map transfer_qty
            current_stock:
              productionTransferInfo[planningItemId]?.current_stock || 0, // Added current_stock
            slice_weight: item.slice_weight || "", // Example if qty is used as slice_weight
            closing_balance: 0, // Placeholder for closing balance
            remarks_delivery: "", // Set to empty or adjust if needed
            decoration_code: item?.production_work_order_item?.decoration_code,
            decoration_name: item?.production_work_order_item?.decoration_name,
            glaze_id: item?.production_work_order_item?.glaze_id,
            status: item?.production_work_order?.status,
          };

          return existingItem || baseItem;
        });

        setList(updatedFilteredItems);
        setPagination(response.data.pagination);

        // Update the global map with new items (only if they don't already exist)
        setAllItemsWithInput((prevMap) => {
          const newMap = new Map(prevMap);
          updatedFilteredItems.forEach((item) => {
            if (!newMap.has(item.id)) {
              newMap.set(item.id, item);
            }
          });
          return newMap;
        });
      } catch (error) {
        console.error("Error searching products:", error);
        // No Swal.fire notification for search errors

        // Set empty list for no results instead of showing error
        setList([]);
      } finally {
        setLoading(false);
      }
    },
    [allItemsWithInput, originalList],
  );

  const selectHandleChanges = (selectedOption, actionMeta) => {
    const name = actionMeta.name;
    const value = selectedOption ? selectedOption.value : "";

    // Update inputs state instead of allItemsWithInput
    setInputs((prevInputs) => ({
      ...prevInputs,
      [name]: value,
    }));
    const newList = list.map((it) => ({ ...it, green_weight: 0 }));
    setList(newList);
    setAllItemsWithInput((prevMap) => {
      const newMap = new Map(prevMap);
      newList.forEach((it) => {
        newMap.set(it.id, { ...it });
      });
      return newMap;
    });
  };

  // Event handler for search input with debouncing
  const handleSearchProduct = (e, page = 1) => {
    const searchValue = e.target.value;
    setSearchProducts(searchValue);

    // Always set loading to true when search input changes
    setLoading(true);

    // Clear any existing timeout
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    // Set a new timeout for the search
    searchTimeout.current = setTimeout(() => {
      const planningId = inputs.planning_id;
      debouncedSearch(searchValue, planningId, page);
    }, 1000); // 2000ms delay before executing search
  };

  const handleClickSearchProduct = () => {
    const data = [...list];
    setList(data);
  };
  const selectedFilterCake = filterCakeOptions.find(
    (o) => o.value === inputs.filter_cake_id,
  );
  const selectedStockQty = selectedFilterCake
    ? Number(selectedFilterCake.stockQty || 0)
    : 0;
  const totalGreenWeightKg = list.reduce(
    (sum, it) => sum + (Number(it.green_weight) || 0) / 1000,
    0,
  );
  const availableFilterCakeStock = Math.max(
    0,
    selectedStockQty - totalGreenWeightKg,
  );

  // const handlePageChange = (page) => {
  //   if (page < 1 || page > pagination.last_page) return; // Prevent invalid page numbers
  //   handlePlanningChange(inputs.planning_id, page); // Call fetchData with the new page number
  // };

  const handlePageChange = (page) => {
    setLoading(true);

    if (page < 1 || page > pagination.last_page) return;

    // Clear any existing timeout
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    if (searchProducts?.trim()) {
      // Use the debounced search directly for pagination
      debouncedSearch(searchProducts, inputs.planning_id, page);
    } else {
      handlePlanningChange(inputs.planning_id, page);
    }
  };

  const renderPagination = () => {
    const { current_page, last_page } = pagination;
    const pageButtons = [];
    let startPage = Math.max(1, current_page - 2);
    let endPage = Math.min(last_page, startPage + 4);

    if (endPage - startPage < 4) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageButtons.push(
        <button
          key={i}
          className={`btn btn-sm mx-1 ${
            i === current_page ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => handlePageChange(i)}
          disabled={i === current_page}
        >
          {i}
        </button>,
      );
    }

    return (
      <div className="d-flex align-items-center justify-content-center my-3">
        <button
          className="btn btn-sm btn-outline-secondary mx-1"
          onClick={() => handlePageChange(1)}
          disabled={current_page === 1}
        >
          First
        </button>
        <button
          className="btn btn-sm btn-outline-secondary mx-1"
          onClick={() => handlePageChange(current_page - 1)}
          disabled={current_page === 1}
        >
          Previous
        </button>
        {pageButtons}
        <button
          className="btn btn-sm btn-outline-secondary mx-1"
          onClick={() => handlePageChange(current_page + 1)}
          disabled={current_page === last_page}
        >
          Next
        </button>
        <button
          className="btn btn-sm btn-outline-secondary mx-1"
          onClick={() => handlePageChange(last_page)}
          disabled={current_page === last_page}
        >
          Last
        </button>
        <span className="mx-2">
          Page {current_page} of {last_page}
        </span>
      </div>
    );
  };

  useEffect(() => {
    // fetchData(pagination.current_page); // Fetch data for the current page
  }); // Fetch data when planningId changes

  return (
    <div>
      <IsLogin></IsLogin>

      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Production and Deliver</h5>
        </div>
        <div className="am-pagebody  row d-flex justify-content-evenly">
          <div className="card pd-20 pd-sm-40 pt-3 col-11">
            <h6 className="card-body-title mg-sm-b-30 pb-3">
              Production and Delivery
            </h6>
            {/* <p>Transfer To Department {inputs.to_department}</p> */}
            <div
              className="row my-1 mb-2 fixed-header"
              style={{
                position: "sticky",
                top: "12%",
                width: "102.1%",
                marginBottom: "10px",
                zIndex: "1200",
                backgroundColor: "white",
                transition: "all 0.3s ease-in-out",
                transform: "translateY(0)",
              }}
            >
              <div className="col-lg  my-2">
                <label>Receipt No</label>
                <input
                  type="text"
                  className="form-control"
                  name="receipt_no"
                  value={inputs.receipt_no}
                  disabled
                />
              </div>

              {/* <div className="col-lg">
                <label>Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="date"
                  value={inputs.date}
                  disabled
                />
              </div> */}
              <div className="col-lg my-2">
                <label>Planning</label>
                <select
                  className="form-control"
                  name="planning_id"
                  value={inputs.planning_id || ""} // Bind to inputs
                  onChange={(e) => handlePlanningChange(e.target.value)}
                >
                  <option value="">Select Planning</option>
                  {planningOptions.map((planning) => (
                    <option key={planning.id} value={planning.id}>
                      {planning.receipt_no}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg my-2">
                <label>
                  Shift <i className="fa fa-star required"></i>
                </label>
                <select
                  className="form-control"
                  name="shift"
                  value={inputs.shift}
                  onChange={handleChange}
                  data-required
                >
                  <option value="">Select Shift</option>
                  <option value="a">A</option>
                  <option value="b">B</option>
                  <option value="c">C</option>
                  <option value="general">General</option>
                </select>
              </div>
              <div className="col-lg my-2">
                <label>
                  Entry Date <i className="fa fa-star required"></i>
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="entry_date"
                  value={inputs.entry_date}
                  onChange={handleChange}
                  data-required
                />
              </div>

              <div className="col-lg" style={{ zIndex: 1000 }}>
                <label>
                  Filter Cake Type <i className="fa fa-star required"></i>
                </label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  name="filter_cake_id"
                  options={filterCakeOptions}
                  onChange={selectHandleChanges}
                  value={filterCakeOptions.find(
                    (option) => option.value === inputs.filter_cake_id,
                  )}
                />

                <span className="text-danger">{error.filter_cake_id}</span>
              </div>
              <div className="col-lg my-2">
                <label>Filter Cake Stock (kg)</label>
                <input
                  className="form-control"
                  type="text"
                  value={availableFilterCakeStock.toFixed(3)}
                  readOnly
                />
              </div>

              {/* <div className="row">
                <label>Transfer To Department {inputs.to_department}</label>
                
              </div> */}
            </div>

            <div
              className="row"
              style={{
                position: "sticky",
                top: "14%",
                width: "102.1%",
                marginBottom: "10px",
                zIndex: "1000",
                backgroundColor: "white",
                transition: "all 0.3s ease-in-out",
                transform: "translateY(0)",
              }}
            >
              <div className="col-lg my-2">
                <label>Search Product</label>
                <input
                  type="search"
                  className="form-control"
                  name="search_product"
                  placeholder="Search Product"
                  value={searchProducts}
                  onChange={handleSearchProduct}
                  onFocus={handleClickSearchProduct}
                />
              </div>
              <div className="col-lg my-2">
                <label>Remarks</label>
                <textarea
                  className="form-control"
                  name="remarks"
                  value={inputs.remarks}
                />
              </div>
              {list?.length > 0 && (
                <>
                  {!isSubmitting && (
                    <div className="col-lg mt-5">
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          setIsSubmitting(true);
                          formSubmit();
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  )}
                  {isSubmitting && (
                    <div className="col-lg mt-5">
                      <button
                        className="btn btn-secondary"
                        onClick={() => setIsSubmitting(false)}
                      >
                        Regain Submit
                      </button>
                    </div>
                  )}
                  {showPagination === true && (
                    <div className="col-lg-5 mt-4">{renderPagination()}</div>
                  )}
                </>
              )}
            </div>
            {/* Item List */}
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row mt-3">
                  {/* {renderPagination()} */}
                  <div className="card-solid">
                    <div className="card-header with-border text-center mt-3">
                      <h5 className="card-title mb-0">
                        Items in the Production
                      </h5>
                    </div>
                  </div>
                  <div className="col-lg">
                    <table
                      className="table table-sm position-relative"
                      style={{ borderCollapse: "collapse", width: "100%" }}
                    >
                      <thead
                        className="fixed-header"
                        style={{
                          position: "sticky",
                          top: "25%",
                          width: "104%",
                          marginBottom: "10px",
                          zIndex: "1000",
                          backgroundColor: "white",
                          transition: "all 0.3s ease-in-out",

                          transform: "translateY(0)",
                        }}
                      >
                        <tr>
                          <th>Product Name</th>
                          <th>Shape Name</th>
                          <th>Company Name</th>
                          <th>Planning Qty</th>
                          {/* <th>Opening Balance</th> */}
                          {/* <th>Total Produced</th> */}
                          {role === "jigger" && (
                            <>
                              <th>Slice Weight</th>
                            </>
                          )}
                          <th>Green Weight</th>
                          <th>Available Qty</th>
                          <th>Total Production</th>
                          {/* <th>Opening Qty</th> */}
                          <th>Production Qty</th> {/* opening + rcved   */}
                          <th>Total Transfered</th>
                          <th>Transfer Qty</th>
                          {/* <th>Return Qty</th> */}
                          {/* {(role === "jigger" ||
                        role === "casting" ||
                        role === "finishing") && <th>Return Qty</th>} */}
                          {/* <th>Return Qty</th> */}
                          {/* <th>Closing Balance</th> total p - total t */}
                          {/* <th>Closing Balance</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {list?.length < 1 ? (
                          <tr>
                            <td colSpan={13} className="text-center">
                              No items found
                            </td>
                          </tr>
                        ) : (
                          list &&
                          list.map((item, index) => {
                            const rowKey = item?.id ?? index;
                            const rowStatusClass =
                              Number(item?.total_transfer_qty) >
                              Number(item?.planning_qty)
                                ? "bg-warning text-white"
                                : Number(item?.total_transfer_qty) ==
                                    Number(item?.planning_qty)
                                  ? "bg-success  text-white"
                                  : "";

                            return (
                              // <tr key={index}>
                              //   <td>
                              //     {item.product_name} ({item.shape}) || {item.company}{" "}
                              //     #{item.production_work_order} <br />
                              //     <b>Planning Qty:</b> {item.planning_qty} ||{" "}
                              //     <b>Total Produced:</b> {item.total_production_qty}{" "}
                              //     <br />
                              //     <b>Decoration Code:</b>{" "}
                              //     {item.decoration_code || "N/A"} ||{" "}
                              //     <b>Decoration Name:</b>{" "}
                              //     {item.decoration_name || "N/A"}
                              //   </td>
                              //   {/* <td>{item.planning_qty}</td>

                              //   <td>{item.total_production_qty}</td> */}
                              //   {(role === "jigger" || role === "casting") && (
                              //     <>
                              //       <td>
                              //         <input
                              //           type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                              //           className="form-control"
                              //           name="slice_weight"
                              //           value={list[index].slice_weight || ""}
                              //           onChange={(e) => handleInputChange(e, index)}
                              //         />
                              //       </td>
                              //       <td>
                              //         <input
                              //           type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                              //           className="form-control"
                              //           name="green_weight"
                              //           value={list[index].green_weight || ""}
                              //           onChange={(e) => handleInputChange(e, index)}
                              //         />
                              //       </td>
                              //     </>
                              //   )}

                              //   <td>
                              //     <input
                              //       type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                              //       className="form-control"
                              //       name="production_qty"
                              //       value={inputs.production_qty}
                              //       onChange={(e) => handleInputChange(e, index)}
                              //     />
                              //   </td>
                              //   <td>{item.total_transfer_qty}</td>
                              //   <td>
                              //     <input
                              //       type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                              //       className="form-control"
                              //       name="transfer_qty"
                              //       value={list[index].transfer_qty}
                              //       onChange={(e) => handleInputChange(e, index)}
                              //     />
                              //   </td>
                              //   <td>
                              //     <input
                              //       type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                              //       className="form-control"
                              //       name="return_qty"
                              //       value={list[index].return_qty || 0}
                              //       onChange={(e) => handleInputChange(e, index)}
                              //     />
                              //   </td>
                              //   {/* {(role === "jigger" ||
                              //     role === "casting" ||
                              //     role === "finishing") && (
                              //     <td>
                              //       <input
                              //         type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                              //         className="form-control"
                              //         name="return_qty"
                              //         value={item.return_qty}
                              //         onChange={(e) => handleInputChange(e, index)}
                              //       />
                              //     </td>
                              //   )} */}
                              //   {/* <td>{item.closing_balance}</td> */}
                              // </tr>

                              <tr
                                key={index}
                                {...getRowProps(rowKey, rowStatusClass)}
                                style={{
                                  fontStyle:
                                    item?.status === "on_test"
                                      ? "italic"
                                      : undefined,
                                  fontWeight:
                                    item?.status === "on_test"
                                      ? "700"
                                      : undefined,
                                  border:
                                    item?.status === "on_test"
                                      ? "2px solid rgb(0, 89, 119)"
                                      : undefined,
                                }}
                              >
                                <td>
                                  {item.product_name} <br />
                                  {/* <b>Planning Qty:</b> {item.planning_qty} ||{" "} */}
                                  {/* <b>Total Produced:</b> {item.total_production_qty}{" "} */}
                                  <br />
                                  {/* <b>Decoration Code:</b>{" "} */}
                                  {/* {item.decoration_code || "N/A"} ||{" "} */}
                                  {/* <b>Decoration Name:</b>{" "} */}
                                  {/* {item.decoration_name || "N/A"} */}
                                </td>
                                <td> {item.shape}</td>
                                <td>
                                  {" "}
                                  {item.company}
                                  <strong>
                                    #{item.production_work_order}
                                  </strong>{" "}
                                </td>
                                <td> {item.planning_qty} </td>

                                {/* <td>{item.total_production_qty}</td> */}

                                {role === "jigger" && (
                                  <>
                                    <td>
                                      <input
                                        type="text"
                                        onInput={(e) =>
                                          (e.target.value =
                                            e.target.value.replace(/\D/g, ""))
                                        }
                                        className="form-control"
                                        name="slice_weight"
                                        value={list[index].slice_weight || ""}
                                        onChange={(e) =>
                                          handleInputChange(e, index)
                                        }
                                      />
                                    </td>
                                  </>
                                )}
                                <td>
                                  <input
                                    type="text"
                                    onInput={(e) =>
                                      (e.target.value = e.target.value.replace(
                                        /\D/g,
                                        "",
                                      ))
                                    }
                                    className="form-control"
                                    name="green_weight"
                                    value={list[index].green_weight || ""}
                                    onChange={(e) =>
                                      handleInputChange(e, index)
                                    }
                                    {...(Number(list[index]?.production_qty) > 0
                                      ? { "data-required": "" }
                                      : {})}
                                  />
                                </td>
                                <td>
                                  {(item.current_stock || 0) +
                                    (list[index].production_qty || 0) -
                                    (list[index]?.transfer_qty || 0) -
                                    (list[index]?.return_qty || 0)}
                                </td>
                                <td>
                                  {item.total_production_qty}{" "}
                                  {/* Total production for the item */}
                                </td>
                                {/* <td>
                                {item.total_production_qty -
                                  item.total_transfer_qty}
                              </td>
                              <td>{item.current_stock}</td> */}
                                <td>
                                  <input
                                    type="text"
                                    onInput={(e) =>
                                      (e.target.value = e.target.value.replace(
                                        /\D/g,
                                        "",
                                      ))
                                    }
                                    className="form-control"
                                    name="production_qty"
                                    value={list[index].production_qty || ""}
                                    onChange={(e) =>
                                      handleInputChange(e, index)
                                    }
                                  />
                                </td>
                                <td>
                                  {item.total_transfer_qty}{" "}
                                  {/* Total transfer for the item */}
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    onInput={(e) =>
                                      (e.target.value = e.target.value.replace(
                                        /\D/g,
                                        "",
                                      ))
                                    }
                                    className="form-control"
                                    name="transfer_qty"
                                    value={list[index].transfer_qty}
                                    onChange={(e) =>
                                      handleInputChange(e, index)
                                    }
                                  />
                                </td>
                                {/* <td>
                                <input
                                  type="text"
                                  onInput={(e) =>
                                  (e.target.value = e.target.value.replace(
                                    /\D/g,
                                    ""
                                  ))
                                  }
                                  className="form-control"
                                  name="return_qty"
                                  value={list[index].return_qty || ""}
                                  onChange={(e) => handleInputChange(e, index)}
                                />
                              </td> */}
                                {/* {(role === "jigger" ||
                              role === "casting" ||
                              role === "finishing") && (
                              <td>
                                <input
                                  type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                  className="form-control"
                                  name="return_qty"
                                  value={item.return_qty}
                                  onChange={(e) => handleInputChange(e, index)}
                                />
                              </td>
                            )} */}
                                {/* <td>{item.closing_balance}</td> */}
                                {/* <td>
                                {(item.current_stock || 0) +
                                  (list[index].production_qty || 0) -
                                  (list[index]?.transfer_qty || 0) -
                                  (list[index]?.return_qty || 0)}
                              </td> */}
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Create;
